import axios from 'axios'
import { BUSCAR_TRECHOS_RESERVAS_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarTrechosReservasItinerario (idItinerario, idEmpresa) {    
  let url = `${URL}/reserva/itinerario/${idItinerario}/empresa/${idEmpresa}/reservas/trechos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_TRECHOS_RESERVAS_ITINERARIO,
        payload: response

      })
  );
}